import React, { useState } from "react";
import Upload from "rc-upload";
import { observer } from "mobx-react-lite";
import { useFormContext } from "./Form";
import { classNames } from "./utils/classNames";
import { useTranslation } from "./hooks/useTranslation";
import { withFormWrapper } from "./withFormWrapper";
import { createUseStyles } from "react-jss";
const styles = {
    root: {
        border: {
            width: 1,
            style: "dashed",
            color: "#D5DFE7",
        },
        backgroundColor: "#F3F9FC",
        width: "100%",
        display: "flex",
        borderRadius: 4,
        padding: 16,
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "inset 0 1px 1px rgb(0 0 0 / 5%)",
        minHeight: 208,
        marginBottom: 10.5,
        "&:focus": {
            outline: "-webkit-focus-ring-color auto 0px;",
            "& .btn-primary": {
                outline: "-webkit-focus-ring-color auto 1px;",
            },
        },
    },
    message: {
        display: "block",
        marginBottom: 8,
        textAlign: "center",
    },
    icon: {
        display: "block",
        textAlign: "center",
        fontSize: 60,
        color: "#D5DFE7",
        marginBottom: 8,
    },
    buttonWrapper: {
        display: "flex",
        justifyContent: "center",
    },
    button: {
        textAlign: "center",
    },
};
const useStyles = createUseStyles(styles);
const UNITS = ["bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
export const RawUploadInput = observer(({ acceptedFileTypes, onChange, name, dropMessage, onStart, beforeUpload, onError, onSuccess, action, runBeforeHandlersOnly = false, }) => {
    const t = useTranslation();
    dropMessage = dropMessage || t("Drop Files Here (max file size: 4GB)");
    const classes = useStyles();
    const [file, setFile] = useState();
    const { values } = useFormContext();
    const handleBeforeUpload = async (file, fileList) => {
        beforeUpload && beforeUpload(file, fileList);
        onChange && onChange(file, values.get(name));
        setFile(file);
        values.set(name, file);
        return !runBeforeHandlersOnly;
    };
    const formatBytes = (bytes) => {
        let l = 0, n = bytes || 0;
        while (n >= 1024 && ++l) {
            n = n / 1024;
        }
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + UNITS[l];
    };
    return (React.createElement(Upload, { action: action, type: "drag", accept: acceptedFileTypes, beforeUpload: handleBeforeUpload, className: classes.root, onStart: onStart, onError: onError, onSuccess: onSuccess },
        React.createElement("span", null,
            React.createElement("span", { className: classNames(classes.icon, "glyphicon-pro", "glyphicon-pro-open") }),
            React.createElement("span", { className: classes.message }, file?.name
                ? `${file?.name} (${formatBytes(file.size)})`
                : dropMessage),
            React.createElement("span", { className: classes.buttonWrapper },
                React.createElement("span", { className: classNames(classes.button, "btn-primary", "btn") }, t("Browse..."))))));
});
export const UploadInput = withFormWrapper({
    WrappedComponent: RawUploadInput,
    options: "validationOnly",
});
